export const uploadIcon = `
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M19.5 13.5H15V24H9V13.5H4.5V12L12 4.5L19.5 12V13.5Z" fill="var(--zbp-svg-primary-color, white)"/>
  <path d="M21 3H3V0H21V3Z" fill="var(--zbp-svg-primary-color, white)"/>
</svg>
`;
